import {Paper} from '@mui/material';
import React from 'react';

const ViewerContainer = ({url, ...rest}) => {
  return (
    <Paper
      // elevation={0}
      variant={'outlined'}
      sx={{
        height: '100%',
        width: '100%',
        // marginRight: 4,
        // borderRadius: 0,
        ...rest,
      }}>
      <iframe src={url} height="100%" width="100%"></iframe>
    </Paper>
  );
};

export default ViewerContainer;
